<template>
  <div
    id="main"
    class="grid"
  >
    <div class="col-1-1">
      <div class="cart-wrapper">
        <h1>Winkelmand</h1>
        <div
          :id="cartId"
          class="mt-xxlg"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  const cartId = ref('cartContainer')
  const { public: publicConfig } = useRuntimeConfig()
  const loadedShoppingCart = useState<boolean>('loaded-shopping-cart', () => false)

  if (loadedShoppingCart.value) {
    // force refresh otherwise iframe problems
    loadedShoppingCart.value = false
    window.location.reload()
  }

  onMounted(async () => {
    nextTick(() => {
      tww('SetItemsListPage', `${publicConfig.siteUrl}/programma`)
      tww('CartContents', cartId.value)

      loadedShoppingCart.value = true
    })
  })

  useHead({
    title: 'Winkelmand',
  })
</script>

<style lang="scss" scoped>
  .cart-wrapper {
    margin: $contentblock-margin 0;
  }
</style>
